/**
 * @fileoverview Drawing event type definitions
 *
 * This file defines the event types emitted by the MapDrawManager
 * and consumed by drawing modes.
 *
 * Events are emitted via native EventTarget/CustomEvent APIs.
 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget
 * @see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent
 */

/**
 * Events emitted by the MapDrawManager
 */
export type DrawingEventList = {
  /**
   * Emitted when markup coordinates are modified during drawing/editing
   *
   * @example
   * ```typescript
   * // Emitting from a draw mode:
   * this.events.emit('markup-coordinates:changed', {
   *   id: 'feature-123',
   *   coordinates: [[-122.5, 45.5]]
   * })
   *
   * // Listening in plugin:
   * drawManager.events.on('markup-coordinates:changed', (event) => {
   *   const { id, coordinates } = event.detail
   *   console.log(`Feature ${id} coordinates updated`)
   * })
   * ```
   */
  'markup-coordinates:changed': {
    /** Feature ID */
    id: string
    /** GeoJSON coordinates array */
    coordinates: number[] | number[][] | number[][][]
  }
}

/**
 * Event names as constants for type-safe usage in JavaScript files
 */
export const MARKUP_COORDINATES_CHANGED = 'markup-coordinates:changed' as const
